import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(@Inject(DOCUMENT) private dom: Document, private router: Router, @Inject(PLATFORM_ID) private platformId: Object,) { }

  SETUPCANONICALLISTENER(url: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.setCanonicalURL(url);
  }

  setCanonicalURL(url: string) {
    if (!isPlatformBrowser(this.platformId)) return;
    let link: HTMLLinkElement = this.dom.querySelector("link[rel='canonical']");
    if (link) { link.setAttribute('href', url);
    } else {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.dom.head.appendChild(link);
    }
  }
}
